export { __decorate as _, __decorate as _ts_decorate } from "tslib";
